import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import TicketTop from './components/TicketTop';
import { getTicketDefaultTab, showHideColumnsOption, defaultRowsPerPage, defaultPage, getTicketTabs, newMainTab } from './TicketController';
import { useCallback } from 'react';
import { debounce, GetQueryParam, getRootDomain, useQuery } from '../../utils/common';
import { updateQueryParams, updateSearchTermQuery } from '../../utils/filter';
import Cookies from 'universal-cookie';
import { useDispatch, useSelector } from 'react-redux';
import TicketsTable, { ticketFilterSchema } from './TicketTable';
import { putToTicketStore, setTicketSideDrawer } from '../../actions/tickets';
import NewTickets from './NewTickets';
import CreateTicket from './CreateTicket';
import { getPreferences } from '../../actions/utils';
import SideDrawer from './SideDrawer';

const ticket_columns = 'ticket_columns';
const cookies = new Cookies();

export const handleFocusOnTable = (event) => {
    if (!['TEXTAREA', 'INPUT', 'SELECT'].includes(event.target.tagName)) {
        const mainContainer = document.querySelector('.BaseTable__table-main');
        const tableBody = mainContainer && mainContainer.querySelector('.BaseTable__body');
        if (tableBody) {
            tableBody.focus();
            tableBody.tabIndex = 0;
        }
    }
}



const Ticket = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { showTicketSideDrawer } = useSelector((state) => state.tickets);
    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);
    const tabs = getTicketTabs(newLoggedUserData.actions, { is_possible_remote_support: newLoggedUserData.user.is_possible_remote_support });
    const query = useQuery();
    let defaultMainTab = getTicketDefaultTab({ query, actions: newLoggedUserData.actions, is_possible_remote_support: newLoggedUserData.user.is_possible_remote_support });
    const [selectedColumns, setSelectedColumns] = useState([]);
    const { ticketsCount } = useSelector((state) => state.tickets);
    const dispatch = useDispatch();
    const limitQueryParam = GetQueryParam('limit', Number) || defaultRowsPerPage;
    const pageQueryParam = GetQueryParam('page', Number) || defaultPage;
    const searchQueryParam = GetQueryParam('query');
    const [clearFilterButton, setClearFilterButton] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
    const [page, setPage] = useState(defaultPage);
    const [searchTerm, setSearchTerm] = useState('');
    const [raiseTicket, setRaiseTicket] = useState(false);
    const ticketTableRef = useRef();
    const tableMainDiv = useRef();
    const [selectedTicketId, setSelectedTicketId] = useState(0);
    const [isMoveToRma, setIsMoveToRma] = useState(false);

    useLayoutEffect(() => {
        dispatch(getPreferences({ user_id: newLoggedUserData.user.id, org_id: newLoggedUserData.org.id, role_id: newLoggedUserData.user.roles.map(role => role.id).join(','), module: 'TICKET', type: 'TAB' }))
    }, [newLoggedUserData, dispatch])

    const onINeedRMASupportClick = ({ ticketId, moveToRma = false }) => {
        setRaiseTicket(true);
        setSelectedTicketId(ticketId);
        setIsMoveToRma(moveToRma);
    }

    useEffect(() => {
        let page = defaultPage;
        let limit = defaultRowsPerPage;
        let searchTerm = '';
        if (limitQueryParam) limit = limitQueryParam;
        if (searchQueryParam) searchTerm = searchQueryParam;
        if (pageQueryParam) page = pageQueryParam;
        setRowsPerPage(limit);
        setSearchTerm(searchTerm);
        setPage(page);
    }, [searchQueryParam, limitQueryParam, pageQueryParam]);

    useEffect(() => {
        let selectedColumns = cookies.get(ticket_columns);
        if (selectedColumns) setSelectedColumns(selectedColumns);
        else setSelectedColumns(showHideColumnsOption);
        return () => dispatch(putToTicketStore({ ticketsCount: {}, ticketList: [] }));
    }, [dispatch]);

    const handleShowHide = (checked, column) => {
        let columns = selectedColumns.filter((col) => column !== col);
        if (checked) columns = [...columns, column];
        setSelectedColumns(columns);
        let expires = new Date();
        expires.setHours(expires.getHours() + 24);
        cookies.set(ticket_columns, columns, { domain: getRootDomain(), expires, path: '/' });
    };
    const [searchParams, setSearchParams] = useSearchParams();

    const goToTicketTab = ({ tab = defaultMainTab }) => {
        const params = {};
        if (searchParams.get(ticketFilterSchema.projects.queryParamKey)) {
            params[ticketFilterSchema.projects.queryParamKey] = searchParams.get(ticketFilterSchema.projects.queryParamKey);
        }
        if (tab) {
            params.tab = tab;
        }
        setSearchParams(params)
    };

    const debouncedSearchCall = useCallback(debounce(updateSearchTermQuery, 300), []);

    const setSeachQuery = (searchTerm, { removeTheseKeys = [] } = {}) => {
        setSearchTerm(searchTerm);
        debouncedSearchCall({ navigate, searchTerm, removeTheseKeys });
    };

    const getHeaderHeight = () => {
        let styleClass = `subContainer px-5 pt-5 title-8`;
        return styleClass;
    };

    const handleClearFilterClick = () => {
        updateQueryParams({
            navigate,
            query: searchQueryParam,
            limit: limitQueryParam,
            page: 1,
            defaultRowsPerPage,
            defaultPage,
            destinationTab: defaultMainTab,
        });
    };

    const closeTicketSideDrawer = useCallback(() => dispatch(setTicketSideDrawer(false)), [dispatch]);

    useEffect(() => {
        return () => closeTicketSideDrawer()
    }, [closeTicketSideDrawer])

    const closeRaise = useCallback(() => {
        setRaiseTicket(false)
        setSelectedTicketId(0);
        setIsMoveToRma(false);
    }, [])

    useEffect(() => {
        document.title = "Tickets";
    }, []);

    useEffect(() => {
        if (tableMainDiv?.current) {
            tableMainDiv.current.focus();
        }
    }, []);


    if (tabs.length === 0) return null;

    return (
        <div ref={tableMainDiv} tabIndex={-1} onKeyDown={handleFocusOnTable} className='overflow-hidden flex w-full'>
            <div className={`${raiseTicket ? 'opacity-25' : ''} ${showTicketSideDrawer ? 'w-7/10' : 'w-full'}`}>
                <div className={getHeaderHeight()}>
                    <div className={`titleContainer sticky w-full z-20`}>
                        <TicketTop
                            title='Tickets'
                            searchPlaceholder='Search Ticket No, Site ID...'
                            goToTicketTab={goToTicketTab}
                            activeTab={defaultMainTab}
                            searchTerm={searchTerm}
                            setSeachQuery={setSeachQuery}
                            selectedColumns={selectedColumns}
                            showHideColumnsOption={showHideColumnsOption}
                            handleShowHide={handleShowHide}
                            ticketsCount={ticketsCount}
                            tabs={tabs}
                            clearFilterButton={clearFilterButton}
                            handleClearFilterClick={handleClearFilterClick}
                            openRaiseTicket={() => setRaiseTicket(true)}
                            getSelectedTickets={() => ticketTableRef?.current?.getSelectedTickets()}
                            ticketId={selectedTicketId}
                        />
                    </div>
                    <div className='relative h-full'>
                        <>
                            <TabComponent
                                selectedColumns={selectedColumns}
                                mainTabName={defaultMainTab}
                                limitQueryParam={limitQueryParam}
                                pageQueryParam={pageQueryParam}
                                searchQueryParam={searchQueryParam}
                                queryParams={location.search}
                                setClearFilterButton={setClearFilterButton}
                                openedMaintab={defaultMainTab}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                ticketTableRef={ticketTableRef}
                                onINeedRMASupportClick={onINeedRMASupportClick}
                            />
                        </>
                    </div>

                </div>
            </div>
            {showTicketSideDrawer && <SideDrawer closeTicketSideDrawer={closeTicketSideDrawer} />}

            {raiseTicket && (
                <div>
                    <CreateTicket closeRaise={closeRaise} selectedTicketId={selectedTicketId} isMoveToRma={isMoveToRma} />
                </div>
            )}
        </div>
    );
};

export default Ticket;

const TabComponent = ({
    totalTicketCount,
    selectedColumns,
    subTabName,
    searchQueryParam,
    limitQueryParam,
    pageQueryParam,
    queryParams,
    setClearFilterButton,
    openedSubTab,
    openedMaintab,
    rowsPerPage,
    page,
    ticketTableRef,
    onINeedRMASupportClick
}) => {
    let TabTicketComponent = null;
    if (openedMaintab === newMainTab.path) {
        TabTicketComponent = NewTickets;
    } else {
        TabTicketComponent = TicketsTable;
    }
    return (
        <TabTicketComponent
            totalTicketCount={totalTicketCount}
            selectedColumns={selectedColumns}
            tabName={subTabName}
            limitQueryParam={limitQueryParam}
            pageQueryParam={pageQueryParam}
            searchQueryParam={searchQueryParam}
            queryParams={queryParams}
            setClearFilterButton={setClearFilterButton}
            openedMaintab={openedMaintab}
            openedSubTab={openedSubTab}
            rowsPerPage={rowsPerPage}
            page={page}
            ref={(elem) => (ticketTableRef.current = elem)}
            onINeedRMASupportClick={onINeedRMASupportClick}
        />
    );
};

export const TicketProgressBar = ({ }) => {
    const ticketProgress = useSelector((state) => state.serviceRequest.ticketProgress)

    let name = ''
    if (ticketProgress?.payload?.type === 'TICKET_CREATE') {
        name = 'Ticket'
    } else if (ticketProgress?.payload?.type === 'ASSET_CREATE') {
        name = 'Asset'
    } else {
        name = 'Site'
    }

    let totalTickets = ticketProgress?.payload?.totalRecords
    let createdTickets = ticketProgress?.payload?.failedRecords
    const progress = (createdTickets / totalTickets) * 100;
    return (
        <div className="max-w-lg mx-auto p-2 w-[20rem] bg-white rounded-lg shadow-lg z-50 absolute bottom-[2.5%]  border-gray-300 border-1
        left-[5%]">
            <h2 className="text-2xl font-semibold text-gray-800 mb-2 text-center">🎟️ {name} Progress</h2>
            <p className="text-gray-600 text-center text-lg">{createdTickets} of {totalTickets} {name} created</p>
            <p className="text-blue-600 text-center font-bold text-lg">({progress.toFixed(2)}%)</p>
            <div className="w-full bg-gray-300 h-6 mt-2 rounded-full overflow-hidden shadow-inner">
                <div
                    className="h-6 bg-gradient-to-r from-blue-500 to-blue-700 transition-all duration-150"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>
        </div >
    );
};
